import src from "IMAGE";
export default { src, width: 197, height: 99, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAARUlEQVR42oWNSwrAIAxEvf81C22hdKEo+EkyTjyABl5mFg8mYH8SjD+LII6xSN5JUYW5oGb4esfbGh5y1Yqb+VNWF04TE48Afi1I4fNRAAAAAElFTkSuQmCC"};
